// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ee4ff5d7","703":"c967e00a"}[chunkId] + ".chunk.js";
};